<template>
    <div>
        <div v-if="item.enable&&page%2==1"
             style="font-family: 'STSong';font-size:14pt;margin-top:1mm !important; margin-left: 33.54mm;margin-right: 33.54mm;float: right">
            <div>- {{page}} -</div>
        </div>
        <div v-if="item.enable&&page%2==0"
             style="font-family: 'STSong';font-size:14pt;margin-top:1mm !important; margin-left: 33.54mm;margin-right: 33.54mm;float: left">
            <div>- {{page}} -</div>
        </div>
    </div>

    <!--                    <div v-if="doc.enablePage" class="sheet-page"-->
    <!--                         style="font-family: 'STSong';font-size:14pt;float:right">-->
    <!--                        <div>─ 1 ─</div>-->
    <!--                    </div>-->
</template>

<script>
    export default {
        name: "DocPage",
        props: {
            item: {},
            page: {
                type: Number
            }
        }
    }
</script>